// import Accordion from "./modules/accordion";
// import CheckScrolled from "./modules/check-scrolled";
import { initDisplayPosition } from "./modules/init-display-position";
// import { updateHeaderHeight } from "./modules/header-height";
import {
	addDeviceClass,
	addLoadedClass,
	addScrollbarWidth,
	addScrolledClass,
} from "./modules/utility";
import { createModal } from "./modules/modal";
import { createNav, createMegaMenu } from "./modules/nav";
import { initClipboardCopy } from "./modules/clipboard-copy";
import { initToggle } from "./modules/toggle";
import { Accordion } from "./modules/accordion";
import { Tab } from "./modules/tab";
import { ScrollAnimation } from "./modules/scroll-animation";
import Swiper from "swiper";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import SwipeFigure from "./modules/swipe-figure";

const nav = createNav(".l-site-header__body", ".l-site-menu-button", {
	preventScroll: true,
	closeOnLinkClick: true,
});

const megaMenu = createMegaMenu(".l-site-nav", { desktopTrigger: "click" });

const MV_AUTOPLAY_DURATION = 4000;

const topMvCarousel = document.querySelector<HTMLElement>(".p-top-mv-carousel");
if (topMvCarousel) {
	topMvCarousel.style.setProperty(
		"--swiper-autoplay-duration",
		`${MV_AUTOPLAY_DURATION}ms`,
	);

	const topMvSlides = topMvCarousel.querySelectorAll(".p-top-mv-carousel__slide");
	const isSingle = topMvSlides.length <= 1;

	if (isSingle) {
		topMvCarousel.classList.add("is-single");
	}

	new Swiper(topMvCarousel, {
		modules: [Navigation, Pagination, Autoplay, EffectFade],
		effect: "fade",
		fadeEffect: { crossFade: true },
		loop: !isSingle,
		speed: 1000,
		navigation: {
			nextEl: topMvCarousel.querySelector<HTMLElement>(
				".p-top-mv-carousel__next",
			),
			prevEl: topMvCarousel.querySelector<HTMLElement>(
				".p-top-mv-carousel__prev",
			),
		},
		pagination: isSingle ? false : {
			el: ".p-top-mv-carousel__pagination",
			clickable: true,
		},
		autoplay: isSingle ? false : {
			delay: MV_AUTOPLAY_DURATION,
			disableOnInteraction: false,
		},
		breakpoints: {
			769: {},
		},
	});
}

// 当院の特徴
// 設備
const equipmentCarousel = document.querySelector<HTMLElement>(
	".p-clinic-equipment",
);
if (equipmentCarousel) {
	const equipmentSlider = equipmentCarousel.querySelector<HTMLElement>(
		".p-clinic-equipment__slider",
	);
	if (equipmentSlider) {
		equipmentSlider.style.setProperty(
			"--swiper-autoplay-duration",
			`${MV_AUTOPLAY_DURATION}ms`,
		);

		new Swiper(equipmentSlider, {
			modules: [Navigation, Autoplay],
			slidesPerView: "auto",
			loop: true,
			centeredSlides: true,
			spaceBetween: 0,
			speed: 700,
			navigation: {
				nextEl: equipmentCarousel.querySelector<HTMLElement>(
					".p-clinic-equipment__next",
				),
				prevEl: equipmentCarousel.querySelector<HTMLElement>(
					".p-clinic-equipment__prev",
				),
			},
			autoplay: {
				delay: MV_AUTOPLAY_DURATION,
				disableOnInteraction: false,
			},
			breakpoints: {
				769: {
					slidesPerView: 3,
					centeredSlides: false,
				},
				1025: {
					slidesPerView: 4,
					centeredSlides: false,
				},
			},
		});
	}
}

// 施設
const facilitiesCarousel = document.querySelector<HTMLElement>(
	".p-clinic-facilities",
);
if (facilitiesCarousel) {
	const facilitiesSlider = facilitiesCarousel.querySelector<HTMLElement>(
		".p-clinic-facilities__slider",
	);
	if (facilitiesSlider) {
		facilitiesSlider.style.setProperty(
			"--swiper-autoplay-duration",
			`${MV_AUTOPLAY_DURATION}ms`,
		);

		const facilitiesWrapper = facilitiesSlider.querySelector<HTMLElement>(
			".p-clinic-facilities__wrapper",
		)!;
		const facilitiesSlides = facilitiesSlider.querySelectorAll<HTMLElement>(
			".p-clinic-facilities__slide",
		)!;
		facilitiesSlides.forEach((item, i) => {
			item.dataset.baseIndex = String(i);
		});

		for (let r = 0; r < 2; r++) {
			facilitiesSlides.forEach((item, i) => {
				const clone = item.cloneNode(true) as HTMLElement;
				clone.classList.add("-clone");
				clone.dataset.baseIndex = String(i);
				facilitiesWrapper.appendChild(clone);
			});
		}

		const facilitiesPagination = facilitiesCarousel.querySelector<HTMLElement>(
			".p-clinic-facilities__pagination",
		);

		const baseCount = facilitiesSlides.length;
		const updateSlide = (swiper: Swiper) => {
			swiper.slides.forEach((slide) => {
				const isActive = slide.classList.contains("swiper-slide-active");
				if (slide.matches("a, button, input, textarea, select, [tabindex]")) {
					slide.tabIndex = isActive ? 0 : -1;
				}

				const index = swiper.slides.indexOf(slide) + 1;
				slide.setAttribute("role", "group");
				slide.setAttribute("aria-label", `${index} / ${swiper.slides.length}`);

				slide
					.querySelectorAll<HTMLElement>(
						"a, button, input, textarea, select, [tabindex]",
					)
					.forEach((el) => {
						el.tabIndex = isActive ? 0 : -1;
					});
			});
		};

		const normalizeToMiddle = (swiper: Swiper) => {
			const base = baseCount;
			const i = swiper.activeIndex;

			const min = base;
			const max = 2 * base - 1;
			const buffer = 2;

			// 中央帯にいれば何もしない
			if (i >= min + buffer && i <= max - buffer) return;

			const activeSlide = swiper.slides[i] as HTMLElement | undefined;
			if (!activeSlide) return;

			const baseIndex = Number(activeSlide.dataset.baseIndex);
			if (Number.isNaN(baseIndex)) return;

			const target = base + baseIndex;

			const wasRunning = !!swiper.autoplay?.running;
			if (wasRunning) swiper.autoplay.stop();

			swiper.slideTo(target, 0, false);
			swiper.updateSlidesClasses();
			swiper.pagination?.render?.();
			swiper.pagination?.update?.();

			if (wasRunning) swiper.autoplay.start();
		};

		const facilitiesSwiper = new Swiper(facilitiesSlider, {
			modules: [Navigation, Autoplay, Pagination],
			slidesPerView: "auto",
			loop: true,
			initialSlide: baseCount,
			centeredSlides: false,
			spaceBetween: 20,
			speed: 700,
			navigation: {
				nextEl: facilitiesCarousel.querySelector<HTMLElement>(
					".p-clinic-facilities__next",
				),
				prevEl: facilitiesCarousel.querySelector<HTMLElement>(
					".p-clinic-facilities__prev",
				),
			},
			// autoplay: {
			// 	delay: MV_AUTOPLAY_DURATION,
			// 	disableOnInteraction: false,
			// },
			pagination: {
				el: facilitiesPagination,
				type: "custom",
				clickable: false,
				renderCustom(swiper: Swiper, current: number, total: number) {
					const base = total / 3;
					const adjustedCurrent = current % base === 0 ? base : current % base;

					return Array.from({ length: base }, (_, index) => {
						const isActive = index === adjustedCurrent - 1;
						return `<span
							class="swiper-pagination-bullet ${isActive ? "swiper-pagination-bullet-active" : ""}"
							data-dot="${index}"
						></span>`;
					}).join("");
				},
			},
			on: {
				init(swiper) {
					requestAnimationFrame(() => {
						swiper.slideTo(baseCount, 0, false);
						swiper.updateSlidesClasses();
						swiper.pagination?.render?.();
						swiper.pagination?.update?.();
					});
					updateSlide(swiper);
				},
				slideChangeTransitionEnd(swiper) {
					updateSlide(swiper);
					const doNormalize = () => normalizeToMiddle(swiper);

					if (swiper.autoplay?.running) {
						requestAnimationFrame(doNormalize);
					} else {
						doNormalize();
					}
				},
				slidesUpdated(swiper) {
					updateSlide(swiper);
				},
			},
			// breakpoints: {
			// 	769: {
			// 		slidesPerView: 3,
			// 		centeredSlides: false,
			// 	},
			// 	1025: {
			// 		slidesPerView: 4,
			// 		centeredSlides: false,
			// 	}
			// },
		});
	}
}

const accordionEls = document.querySelectorAll("[data-accordion]");
for (const accordionEl of accordionEls) {
	if (accordionEl instanceof HTMLButtonElement) {
		new Accordion(accordionEl);
	} else {
		console.warn("Invalid element type for Accordion:", accordionEl);
	}
}
document
	.querySelectorAll<HTMLElement>("[data-tab]")
	.forEach((el) => new Tab(el));

addLoadedClass();
addScrollbarWidth();
addDeviceClass();
addScrolledClass();
initDisplayPosition();
initClipboardCopy();
initToggle();
// new SmoothScroll({ ignoreSelector: ":not(.ez-toc-link)" });
new ScrollAnimation();
new SwipeFigure();
